import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6673cce8&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6673cce8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\privateItem\\sct-shop\\sct-shop-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6673cce8')) {
      api.createRecord('6673cce8', component.options)
    } else {
      api.reload('6673cce8', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=6673cce8&scoped=true", function () {
      api.rerender('6673cce8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/maintain/index.vue"
export default component.exports